import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";

import { CPanel, CForm, P } from "@appcues/component-library";
import { updateAccountMeta } from "actions/account/meta";
import {
  selectAccountMeta,
  selectAccountMetaSynced
} from "reducers/account/meta";

export const CustomerSupportPanel = ({
  loaded,
  initialValues: { testUrl, testUsername, testPassword },
  onSubmit
}) => {
  if (!loaded) {
    return false;
  }

  return (
    <CPanel title="Customer support">
      <P>
        To improve your support experience, you can provide our team with a demo
        login for your application. We use that info to troubleshoot issues in
        your test environment and verify any flows you've created look extra
        beautiful.
      </P>
      <P>
        <strong>Security note:</strong> Please do not provide us with login
        credentials that could jeopardize the security of your organization.
        Appcues claims no responsibility over the security of your product or
        company, so we ask that you adhere to the security guidelines of your
        organization before providing this information.
      </P>
      <P>
        If you are unsure, run this by one of the techie folks on your team.
      </P>
      <CForm
        initialValues={{
          testUrl,
          testUsername,
          testPassword
        }}
        onSubmit={onSubmit}
        marginTop={40}
      >
        <CForm.Field
          name="testUrl"
          label="Test environment URL"
          placeholder="https://staging.yourapp.com"
        />
        <CForm.Field
          name="testUsername"
          label="Test username"
          placeholder="test@yourapp.com"
        />
        <CForm.Field
          name="testPassword"
          label="Test password"
          placeholder="notAVeryGoodPassword"
          type="password"
        />
        <CForm.SubmitButton type="positive">Save</CForm.SubmitButton>
      </CForm>
    </CPanel>
  );
};

CustomerSupportPanel.propTypes = {
  initialValues: PropTypes.shape({
    testUrl: PropTypes.string,
    testUsername: PropTypes.string,
    testPassword: PropTypes.string
  }),
  loaded: PropTypes.bool,
  onSubmit: PropTypes.func
};

CustomerSupportPanel.defaultProps = {
  initialValues: { testUrl: "", testUsername: "", testPassword: "" },
  isMetaSynced: false
};

const mapStateToProps = state => {
  const { testUrl, testUsername, testPassword } = selectAccountMeta(state);
  return {
    loaded: selectAccountMetaSynced(state),
    initialValues: {
      testUrl,
      testUsername,
      testPassword
    }
  };
};

const mapDispatchToProps = {
  onSubmit: values => updateAccountMeta(values)
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CustomerSupportPanel);
